import { render, staticRenderFns } from "./DailyLogin.vue.vue?vue&type=template&id=08d1df78&"
import script from "./DailyLogin.vue.vue?vue&type=script&lang=js&"
export * from "./DailyLogin.vue.vue?vue&type=script&lang=js&"
import style0 from "./DailyLogin.vue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports